<template>
  <div class="step1">
    <PlateTitle title="投保信息" />
    <!-- <a-spin :spinning="spinning"> -->
    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 10 }">
      <a-form-item label="投标人名称" has-feedback>
        <span>{{ dataSourceInfo.name }}</span>
      </a-form-item>
      <a-form-item label="投标人统一社会信用代码" has-feedback>
        <span>{{ dataSourceInfo.creditCode }}</span>
      </a-form-item>
      <a-form-item label="投标登记号" has-feedback>
        <span>{{ dataSourceInfo.applyNo }}</span>
      </a-form-item>
      <a-form-item label="担保金额" has-feedback>
        <span>{{ dataSourceInfo.sumAmount }}</span>
      </a-form-item>
    </a-form>
    <PlateTitle title="开票申请" />
    <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 8 }">
      <a-form-item label="选择开票类型" has-feedback>
        <a-select
          v-decorator="[
            'invoiceType',
            { rules: [{ required: true, message: '请选择开票类型' }] }
          ]"
          placeholder="请选择开票类型"
          style="width: 280px"
          @change="handleChane"
        >
          <a-select-option
            v-for="(item, index) in typeArray"
            :key="index"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="发票抬头" has-feedback>
        <a-input
          :maxLength="20"
          v-decorator="[
            'invoiceHead',
            { rules: [{ required: true, message: '请输入发票抬头' }] }
          ]"
          placeholder="请输入发票抬头"
          style="width: 280px"
        />
      </a-form-item>
      <a-form-item label="纳税人识别号" has-feedback>
        <a-input
          :maxLength="20"
          v-decorator="[
            'invoiceCuscCode',
            { rules: [{ required: true, validator: getInvoiceCuscCode }] }
          ]"
          placeholder="请输入纳税人识别号"
          style="width: 280px"
        />
      </a-form-item>
      <template v-if="radioNum == 3">
        <a-form-item label="企业注册地址" has-feedback>
          <a-input
            :maxLength="50"
            v-decorator="[
              'addInfo',
              { rules: [{ required: true, message: '请输入企业注册地址' }] }
            ]"
            placeholder="请输入企业注册地址"
            style="width: 280px"
          />
        </a-form-item>
        <a-form-item label="联系电话" has-feedback>
          <a-input
            v-decorator="[
              'phoneNo',
              { rules: [{ required: true, validator: compareToFirstPhone }] }
            ]"
            placeholder="请输入联系电话"
            style="width: 280px"
          />
        </a-form-item>
        <a-form-item label="开户行" has-feedback>
          <a-input
            :maxLength="20"
            v-decorator="[
              'bankInfo',
              { rules: [{ required: true, message: '请输入开户行' }] }
            ]"
            placeholder="请输入开户行"
            style="width: 280px"
          />
        </a-form-item>
        <a-form-item label="开户账号" has-feedback>
          <a-input
            v-decorator="[
              'bankAcc',
              { rules: [{ required: true, validator: getBAnk }] }
            ]"
            placeholder="请输入开户账号"
            style="width: 280px"
          />
        </a-form-item>
        <a-form-item label="收件人" has-feedback>
          <a-input
            :maxLength="20"
            v-decorator="[
              'addressee',
              { rules: [{ required: true, message: '请输入收件人' }] }
            ]"
            placeholder="请输入收件人"
            style="width: 280px"
          />
        </a-form-item>
        <a-form-item label="收件人手机号" has-feedback>
          <a-input
            v-decorator="[
              'addresseePhone',
              { rules: [{ required: true, validator: compareToFirstPhone }] }
            ]"
            placeholder="请输入收件人手机号"
            style="width: 280px"
          />
        </a-form-item>
        <a-form-item label="收件地址" has-feedback>
          <a-input
            :maxLength="50"
            v-decorator="[
              'address',
              { rules: [{ required: true, message: '请输入收件地址' }] }
            ]"
            placeholder="请输入收件地址"
            style="width: 280px"
          />
        </a-form-item>
      </template>
      <template v-else>
        <a-form-item label="电子邮箱" has-feedback>
          <a-input
            v-decorator="[
              'invoiceEmail',
              { rules: [{ required: true, validator: getEmail }] }
            ]"
            placeholder="电子邮箱"
            style="width: 280px"
          />
        </a-form-item>
      </template>

      <PlateTitle title="投保信息"> </PlateTitle>

      <a-form-item label="出函机构" has-feedback class="img_logo">
        <div
          class="img_list"
          v-decorator="[
            'partnerCode',
            {
              rules: [
                {
                  required: dataSourceInfo.partnerCode ? false : true,
                  message: '请点击选择'
                }
              ]
            }
          ]"
        >
          <template v-for="item in logoArray">
            <div
              :id="dataSourceInfo.partnerCode ? 'cur' : 'no'"
              class="box"
              @click="handleClick(item)"
            >
              <div class="logo_box" :id="item.isTrue ? 'cur_i' : ''">
                <img :src="item.logoPath" alt="" />
              </div>
            </div>
          </template>
        </div>
      </a-form-item>
      <a-form-item label="保费" class="img_logo">
        <div class="money">{{ dataSourceInfo.sumPremium }}元</div>
      </a-form-item>
      <a-form-item
        v-if="dataSourceInfo.effectiveType == 2"
        label="保函有效期"
        has-feedback
      >
        <a-select
          v-decorator="[
            'period',
            { rules: [{ required: true, message: '请选择保函有效期' }] }
          ]"
          placeholder="请选择保函有效期"
          style="width: 280px"
        >
          <a-select-option
            v-for="(item, index) in timeArray"
            :key="index"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="手机号" has-feedback>
        <a-input
          v-decorator="[
            'mobile',
            { rules: [{ required: true, validator: compareToFirstPhone }] }
          ]"
          placeholder="请输入手机号"
          style="width: 280px"
        />
      </a-form-item>
      <a-form-item label="验证码" class="code">
        <a-input
          v-decorator="[
            'code',
            { rules: [{ required: true, validator: compareToFirstCode }] }
          ]"
          placeholder="请输入验证码"
          style="width: 280px"
        />
        <img :src="codeImg" alt="" @click="code" />
      </a-form-item>
      <a-form-item label="短信验证码" class="code">
        <a-input
          v-decorator="[
            'phCode',
            { rules: [{ required: true, validator: compareToFirstPhcode }] }
          ]"
          placeholder="请输入短信验证码"
          style="width: 280px"
        />
        <a v-if="isTime" @click="phoneCode">获取验证码</a>
        <span v-else>{{ time }}s重新获取</span>
      </a-form-item>
    </a-form>
    <!-- </a-spin> -->
  </div>
</template>

<script>
import PlateTitle from "@/components/PlateTitle";
import {
  infoinformation,
  getSignUrl,
  startSign,
  code,
  phoneCode,
  getList,
  getChannelInfo,
  getDictInfo
} from "@/api/insure.js";
export default {
  name: "Step1",
  components: {
    PlateTitle
  },
  props: {
    step: {
      type: Number,
      default: 0
    },
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    spinning: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uuid: "",
      codeImg: "",
      isTime: true,
      time: 60,
      form: this.$form.createForm(this, { name: "loginForm" }),
      orderNo: "",
      rules: {},
      readDocMap: "", // 已阅读并同意文件
      certTypeList: [], // 身份证件类型
      typeArray: [], //选择开票类型
      timeArray: [],
      logoArray: [],
      radioNum: null
    };
  },
  computed: {
    dataSourceInfo() {
      return this.dataSource;
    }
  },
  mounted() {
    this.code();
    // this.init();
  },
  methods: {
    handleChane(e) {
      this.radioNum = e;
    },
    // 获取orderNo参数 调取已阅读接口
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    initInfo() {
      this.form.setFieldsValue({
        invoiceType: this.dataSourceInfo.invoiceType,
        invoiceHead: this.dataSourceInfo.invoiceHead,
        invoiceCuscCode: this.dataSourceInfo.invoiceCuscCode,
        invoiceEmail: this.dataSourceInfo.invoiceEmail,
        period: this.dataSourceInfo.period,
        mobile: this.dataSourceInfo.mobile,
        partnerCode: this.dataSourceInfo.partnerCode,
        addInfo: this.dataSourceInfo.addInfo,
        bankInfo: this.dataSourceInfo.bankInfo,
        bankAcc: this.dataSourceInfo.bankAcc,
        addressee: this.dataSourceInfo.addressee,
        addresseePhone: this.dataSourceInfo.addresseePhone,
        address: this.dataSourceInfo.address
      });
    },
    init() {
      this.orderNo = this.getQueryString("orderNo");
      getChannelInfo({ orderNo: this.orderNo }).then(res => {
        this.readDocMap = res.data.readDocMap;
        this.timeArray = res.data.effectiveTime;
      });
      getDictInfo("invoiceType").then(({ data: data }) => {
        this.typeArray = data.data;
      });
      getList({ orderNo: this.orderNo }).then(({ data: data }) => {
        this.logoArray = data.data;
        if (this.dataSourceInfo.partnerCode) return;
        if (this.logoArray.length == 1) {
          this.$parent.getList(this.logoArray[0]);
          this.form.setFieldsValue({
            partnerCode: this.logoArray[0].partnerCode
          });
        }
      });
    },
    /* 图片验证码 */
    code() {
      code().then(res => {
        this.codeImg = res.data.img;
        this.uuid = res.data.uuid;
      });
      this.orderNo = this.getQueryString("orderNo");
      getChannelInfo({ orderNo: this.orderNo }).then(res => {
        this.timeArray = res.data.effectiveTime;
      });
    },
    /* 获取验证码 */
    phoneCode() {
      this.timer = "";
      if (
        this.form.instances.mobile.stateValue !== "" &&
        this.form.instances.code.stateValue !== ""
      ) {
        phoneCode({
          codeKey: this.uuid,
          code: this.form.instances.code.stateValue,
          phoneNum: this.form.instances.mobile.stateValue
        }).then(({ data: data }) => {
          if (data.status === 200) {
            this.isTime = false;
            this.timer = setInterval(this.countDown, 1000);
          } else {
            this.$message.error(data.message);
          }
        });
      } else {
        this.$message.warning("手机号码和图形验证码不为空");
      }
    },
    countDown() {
      if (this.time > 0) {
        this.time--;
      } else {
        this.time = 60;
        this.isTime = true;
        clearInterval(this.timer);
      }
    },
    // 自定义校验
    getInvoiceCuscCode(rule, value, callback) {
      if (!value) {
        callback("请输入18-20个字符的纳税人识别号");
      } else if (value.length < 18 || value.length > 21) {
        callback("请输入18-20个字符的纳税人识别号");
      } else {
        callback();
      }
    },
    // 自定义校验
    compareToFirstName(rule, value, callback) {
      if (value === "" || !value) {
        callback("请输入经办人姓名");
      } else {
        callback();
      }
    },
    getBAnk(rule, value, callback) {
      const pattern = /^[1-9]\d{9,29}$/;
      if (pattern.test(value) && value) {
        callback();
      } else {
        callback("请输入正确的开户号");
      }
    },
    compareToFirstPhone(rule, value, callback) {
      const pattern = /^1[3|4|5|7|8|9][0-9]{9}$/;
      if (pattern.test(value) && value) {
        callback();
      } else {
        callback("请输入正确的手机号");
      }
    },
    compareToFirstCode(rule, value, callback) {
      if (value === "" || !value) {
        callback("请输入图形验证码");
      } else {
        callback();
      }
    },
    compareToFirstPhcode(rule, value, callback) {
      if (value === "" || !value) {
        callback("请输入短信验证码");
      } else {
        callback();
      }
    },

    getEmail(rule, value, callback) {
      const pattern = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (pattern.test(value) && value) {
        callback();
      } else {
        callback("请输入正确电子邮箱");
      }
    },
    // 点击选中
    handleClick(item) {
      if (this.dataSourceInfo.partnerCode) return;
      this.form.setFieldsValue({
        partnerCode: item.partnerCode
      });
      this.$parent.getList(item);
      this.logoArray.forEach(items => {
        items.isTrue = false;
      });
      this.$set(item, "isTrue", !item.isTrue);
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="less" scoped>
.step1 {
  .img_logo {
    .img_list {
      display: flex;
      flex-wrap: wrap;
      .box {
        margin-right: 10px;
      }
    }
    #cur {
      cursor: no-drop;
    }
    #no {
      cursor: pointer;
    }
    #cur_i {
      border: 2px solid #1890ff;
    }
    .logo_box {
      width: 100%;
      height: 94px;
      border: 1px solid #8b8b8b;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .money {
      font-size: 22px;
      color: #d9001b;
    }
  }

  /deep/ .ant-row {
    display: flex;
    margin-left: 15%;
    // justify-content: center;
  }

  .hrefa {
    // color: #666
    color: #1890ff;
  }

  .code {
    img {
      position: absolute;
      cursor: pointer;
      left: 185px;
      top: -5px;
      height: 30px;
    }

    a,
    span {
      position: absolute;
      width: 80px;
      left: 200px;
    }
  }
}

.palnList {
  display: flex;
  flex-wrap: wrap;

  .palnListBox {
    display: flex;
    // flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 425px;
    height: 80px;
    margin-bottom: 20px;
    position: relative;
    background: #ffffff;
    border: 2px solid #d2e1ec;
    border-radius: 4px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #6a95b5;
    margin-right: 30px;
    cursor: pointer;
    // padding-left: 25px;
    transition: all 0.5s;

    .palnText {
      margin: 20px 0 0 17px;

      span {
        font-size: 16px;
        font-weight: bold;
      }

      p {
        font-size: 14px;
      }
    }

    img {
      // width: 330px;
      // height: 75px;
      height: 74px;
    }

    .feilv {
      position: absolute;
      text-align: center;
      top: -2px;
      right: -2px;
      width: 60px;
      height: 20px;
      background: #f83333;
      border-radius: 0px 4px 0px 10px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .palnListBoxAct {
    border: 2px solid #36a4ff;
    background: linear-gradient(-30deg, #e6f3fd 0%, #ffffff 100%);
    color: #007ce2;
    transition: all 0.5s;
  }
}

.content {
  margin-left: 15%;
}

.tit {
  font-size: 18px;
  font-weight: 500;
  margin: 20px 0;
}

.title {
  font-size: 16px;
  font-weight: 600;
  margin: 30px 0 30px 157px;

  span {
    font-size: 14px;
    font-weight: 300;
    padding-left: 10px;
    color: black;
  }
}

::v-deep .ant-form-item-control {
  margin-left: 50px;
  width: 370px;
}

::v-deep .ant-form-item-label {
  text-align: left;
}

.items {
  margin-left: 0 !important;

  ::v-deep .ant-form-item-control {
    margin-left: 0 !important;
  }

  ::v-deep .ant-col {
    height: 30px;
  }

  ::v-deep .ant-upload-list-item-card-actions .anticon {
    display: none;
  }
}

.items2 {
  margin-left: 0 !important;

  ::v-deep .ant-form-item-control {
    margin-left: 0 !important;
    width: 260px;
  }

  ::v-deep .ant-col {
    height: 30px;
  }
}

.plastDialog2 {
  ::v-deep .ant-modal-footer {
    display: none;
  }
}

.formItem {
  ::v-deep .ant-form-item-label {
    padding-left: 11px;
  }
}

.requiredUpload {
  position: absolute;
  left: -280px;
  top: 13px;
  margin-right: 4px;
  color: #f5222d;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
}

.sgin {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
</style>
